import { SxProps, Theme, alpha } from '@mui/material';

export const drawerRootStyles: SxProps<Theme> = {
  zIndex: (theme) => theme.zIndex.drawer + 1,
};

export const drawerPaperStyles: SxProps<Theme> = {
  width: 367,
  height: '100vh',
  backgroundColor: (theme) => theme.palette.grey[900],
  color: (theme) => theme.palette.common.white,
  borderRadius: '20px 0 0 20px',
};

export const searchContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const searchInputStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.grey[800],
  borderRadius: 1,
  color: (theme) => theme.palette.common.white,
};

export const filterButtonStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.secondary.main,
  borderRadius: 1,
  '&:hover': {
    backgroundColor: (theme) => theme.palette.secondary.dark,
  },
};

export const badgeStyles: SxProps<Theme> = {
  '& .MuiBadge-badge': {
    top: -10,
    right: -10,
  },
};

export const cardRootStyles: SxProps<Theme> = {
  backgroundColor: (theme) => alpha(theme.palette.common.black, 0.5),
  color: (theme) => theme.palette.common.white,
  borderRadius: 2,
  border: (theme) => `1px solid ${theme.palette.divider}`,
};

export const cardContentStyles: SxProps<Theme> = {
  display: 'grid',
  gap: 3,
  ':last-child': {
    padding: 2,
  },
};

export const cardGridStyles: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 1,
};

export const labelStyles: SxProps<Theme> = {
  color: 'grey.400',
};

export const valueStyles = (isBold?: boolean): SxProps<Theme> => ({
  textAlign: 'right',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  ...(isBold && { fontWeight: 'bold' }),
});

export const linkButtonStyles: SxProps<Theme> = {
  color: (theme) => theme.palette.text.primary,
  borderRadius: 1,
};

export const titleStyles: SxProps<Theme> = {
  padding: 2,
};

export const dividerStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.grey[600],
};

export const contentStyles: SxProps<Theme> = {
  padding: 3,
  gap: 4,
};
